<template>
  <div>
    <v-container >
      <CRUDList
        :canAdd="true"
        :canEdit="true"
        :canSave="true"
        :canDelete="true"
        :baseCrudKey="baseCrudKey"
        :headers="headers"
        :createNewItem="newItemDialog"
        toolbarTitle="Reconciliation Codes"
        @loadCRUDList="handleLoadCRUDList"
        @upsertItem="upsrtTransaction"
        @emitDeleteRowItem="deleteTransaction"
      >
        <template v-slot:[`editedItem`]="{}">
          <TransactionEditedItem :baseCrudKey="baseCrudKey"/>
        </template>
        <template v-slot:[`additionalTools`]="{}">
          <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            depressed
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="insertReconcialionCode"
             >
             Insert Reconciliation Codes
          </v-btn>
          </template>
            <span>Insert Reconciliation Codes</span>
        </v-tooltip>
        </template>
      </CRUDList>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CRUDList from '../../common/base/crud/CRUDList.vue';
import TransactionEditedItem from './TransactionEditedItem.vue';

const getHeaders = (canDelete) => {
  const headers = [
    { text: 'Add Deduct', value: 'addDeduct' },
    { text: 'Description', value: 'description' },
  ];
  if (canDelete) {
    headers.push({ text: 'Actions', value: 'actions', sortable: false });
  }
  return headers;
};

export default {
  name: 'bankCodes',
  components: {
    CRUDList,
    TransactionEditedItem,
  },
  data: () => ({
    headers: [],
    baseCrudKey: 'bankCodes',
  }),
  props: {
  },
  created() {
    this.headers = getHeaders(this.canDelete);
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'item',
      'items',
    ]),
    ...mapGetters(['todaysDate']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('glDaily/saiBankCodes', [
      'loadSaiBankCodesTrans',
      'insertReconCode',
      'upsertSaiBankCodesTrans',
      'deleteSaiBankCodesTrans',
    ]),
    handleLoadCRUDList() {
      const { baseCrudKey } = this;
      const criteria = this.criteriaState;
      delete criteria.fiscalYear;
      this.loadSaiBankCodesTrans({
        criteria,
        baseCrudKey,
      });
    },
    async insertReconcialionCode() {
      if (window.confirm('Are you sure want to insert Reconciliation Codes?')) {
        const bulkWriteStatus = await this.insertReconCode();
        if (bulkWriteStatus.ok && bulkWriteStatus.ok === 1) {
          this.handleLoadCRUDList();
        }
      }
    },
    upsrtTransaction(item) {
      const { baseCrudKey } = this;
      this.upsertSaiBankCodesTrans({ item, baseCrudKey });
    },
    deleteTransaction(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteSaiBankCodesTrans({ item, baseCrudKey });
      }
    },
    newItemDialog() {
      const newItem = {
        addDeduct: '',
        description: '',
      };
      return newItem;
    },
  },
};
</script>
